import { StyledDropdown } from 'components/shared/Dropdown.styled';
import styled from 'styled-components';
import {
  color,
  container,
  fontSize,
  fontWeight,
  spacing,
  zindex,
  screen,
  radius
} from 'theme';

export const StyledNav = styled.div`
  display: none;
  background-color: ${color('cyan_900')};
  position: sticky;
  top: 0;
  transition: top 0.3s;
  z-index: ${zindex('talentEngineNav')};

  @media (max-width: ${screen('lgMax')}) {
    &.mobile {
      display: block;
    }
  }

  @media (min-width: ${screen('lg')}) {
    &.desktop {
      display: block;
    }
  }

  .is-headroom-pinned & {
    top: ${spacing('xl4')};
  }
`;

export const StyledNavContainer = styled.div`
  max-width: ${container('xlMax')};
  padding: 10px ${spacing('md')};
  margin: auto;
  display: flex;
  align-items: center;
  gap: ${spacing('xl2')};
`;

export const StyledNavLogo = styled.img`
  height: ${spacing('lg')};
  cursor: pointer;
`;

export const StyledNavItem = styled.div`
  font-size: ${fontSize('md')};
  font-weight: ${fontWeight('black')};
  color: ${color('text_white')};
  position: relative;

  > svg {
    color: inherit;
    width: ${spacing('xs')};
  }

  > a {
    color: inherit;
    transition: 0.3s;

    &:hover {
      opacity: 0.5;
    }

    &:active {
      opacity: 0.25;
    }

    &.active {
      color: ${color('active')};
    }
  }

  > button {
    background-color: transparent;
    border: 0;
    padding: 0;
    display: flex;
    align-items: center;
    gap: ${spacing('sm')};
    color: inherit;
    font-weight: inherit;
    font-size: inherit;
    font-family: inherit;
    appearance: none;
    cursor: pointer;
    transition: 0.3s;

    &:hover {
      opacity: 0.5;
    }

    &:active {
      opacity: 0.25;
    }

    &.active {
      color: ${color('active')};
    }
  }

  ${StyledDropdown} a {
    color: ${color('text_default')};
    span {
      white-space: nowrap;
    }
  }
`;

export const StyledNavTrigger = styled.button`
  background-color: transparent;
  border: 0;
  padding: 0;
  display: flex;
  align-items: center;
  gap: ${spacing('sm')};
  color: ${color('text_white')};
`;

export const StyledNavMobileMenu = styled.div`
  background-color: ${color('cyan_900')};
  display: none;
  width: 100%;
  z-index: ${zindex('talentEngineNav')};
  overflow-x: auto;
  padding-bottom: ${spacing('xl')};

  &.active {
    display: block;
    position: absolute;
    top: 3.5rem;
    height: calc(100vh - 3.5rem);
  }

  ${StyledNavItem} {
    padding: ${spacing('sm')} ${spacing('md')};
  }

  ${StyledDropdown} {
    position: static;
    background-color: unset;
    border: 0;
    box-shadow: unset;
    max-height: unset;
    padding: ${spacing('sm')} 0 0;

    a {
      padding: ${spacing('xs')};
      color: ${color('text_white')};
    }

    svg {
      color: ${color('text_white')};
    }

    li {
      border-radius: ${radius('sm')};

      &:not(.active):hover {
        background-color: unset;
        opacity: 0.5;
      }

      &.active a,
      &.active svg {
        color: ${color('text_over_active')};
      }
    }
  }
`;
